import { Component, input } from '@angular/core';
import { ModifiableNamedIdentityWithCreatorDTO } from '../../../services/api/api';

@Component({
  selector: 'sb-comp-display-modified',
  standalone: false,
  templateUrl: './display-modified.component.html',
  styleUrl: './display-modified.component.scss',
})
export class DisplayModifiedComponent {
  data = input.required<ModifiableNamedIdentityWithCreatorDTO>();
  hideIcon = input<boolean>(false);
  reverse = input<boolean>(false);
  dateFormat = input<string>('dd.MM.yy HH:mm:ss');
  hideTooltip = input(false);
}
